export function boolFromUnknown(v: unknown): boolean {
    if (v === true || v === false) {
        return v;
    }
    if (v === 'false' || v === '0' || v === '') {
        return false;
    }
    if (v === 'true' || v === '1') {
        return true;
    }
    return Boolean(v);
}

export function intFromUnknown(v: unknown, fallback: number): number {
    if (typeof v === 'number' && !Number.isNaN(v)) {
        return v;
    }
    if (typeof v === 'string' && v !== '') {
        const n = Number.parseInt(v, 10);
        if (!Number.isNaN(n)) {
            return n;
        }
    }
    return fallback;
}

export function strFromUnknown(v: unknown, fallback = ''): string {
    return v == null || v === undefined ? fallback : String(v);
}

export function isPlainObject(v: unknown): v is Record<string, unknown> {
    return Boolean(v) && typeof v === 'object' && !Array.isArray(v);
}
